import type { TaskResult } from "../types";

function normalizeFormula(value: string | undefined): string {
  return (value ?? "").replace(/\$/g, "").replace(/\s+/g, "").replace(/^=/, "").toUpperCase();
}

export async function gradeProject23(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  try {
    await Excel.run(async (context) => {
      const table = context.workbook.worksheets.getItem("Horas de empleados").tables.getItemAt(0);
      table.load("showTotals");
      await context.sync();

      results.push({ taskId: 2, passed: table.showTotals === true });
    });
  } catch {
    results.push({ taskId: 2, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Horas de empleados");
      const range = ws.getRange("H4:H16");
      const totals = ws.getRange("J4:J16");
      range.load("formulas,values");
      totals.load("values");
      await context.sync();

      let allOk = true;
      for (let i = 0; i < 13; i++) {
        const formula = normalizeFormula(String(range.formulas[i][0] ?? ""));
        const value = String(range.values[i][0] ?? "").trim().toUpperCase();
        const total = Number(totals.values[i][0]);
        const okIf = formula.includes("IF(") || formula.includes("SI(");
        const expectedYes = total > 40;
        const isYes = value === "SI" || value === "SÍ";
        const isNo = value === "NO";
        const okValue = expectedYes ? isYes : isNo;
        if (!okIf || !okValue) {
          allOk = false;
          break;
        }
      }
      results.push({ taskId: 3, passed: allOk });
    });
  } catch {
    results.push({ taskId: 3, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const cell = context.workbook.worksheets.getItem("Horas de empleados").getRange("I4");
      cell.load("formulas,values");
      await context.sync();

      const formula = normalizeFormula(String(cell.formulas[0][0] ?? ""));
      const value = String(cell.values[0][0] ?? "").trim();
      const hasUpper = formula.includes("UPPER(") || formula.includes("MAYUSC(");
      const refOk =
        formula.includes("A4") ||
        formula.includes("[@EMPLEADO]") ||
        formula.includes("[EMPLEADO]");
      results.push({ taskId: 4, passed: hasUpper && refOk && value === "EMILIO" });
    });
  } catch {
    results.push({ taskId: 4, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Tiempo promedio de llamada");
      const charts = sheet.charts;
      charts.load("items");
      await context.sync();

      let passed = false;
      for (const chart of charts.items) {
        chart.load("chartType");
        await context.sync();

        const tipo = String(chart.chartType).toLowerCase();
        if (!tipo.includes("3dcolumn")) continue;

        // Verify chart uses Friday data (should have 1 series named "Vie")
        chart.series.load("count");
        await context.sync();

        if (chart.series.count !== 1) break;

        const series0 = chart.series.getItemAt(0);
        series0.load("name");
        await context.sync();

        const nombre = (series0.name || "").toLowerCase();
        if (nombre.includes("vie")) {
          passed = true;
        }
        break;
      }

      results.push({ taskId: 5, passed });
    });
  } catch {
    results.push({ taskId: 5, passed: false });
  }

  return results;
}
